import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import "./SegmentedBar.css";
import { greyPalette } from "../../helpers/constants/colorPalettes";

class SegmentedBarSegment extends PureComponent {
    constructor(props) {
        super(props);
        this.rect = null;
        // this.state = {
        //     fx: 'transition-scale-out'
        // }
    }

    updateDimensions = e => {
        e.preventDefault();
        this.rect = ReactDOM.findDOMNode(
            this.refs._root
        ).getBoundingClientRect();
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    componentDidMount() {
        this.rect = ReactDOM.findDOMNode(
            this.refs._root
        ).getBoundingClientRect();
        this.forceUpdate();
        window.addEventListener("resize", this.updateDimensions);
    }

    render() {
        const { ratio, color, threshold } = this.props;
        return (
            <div ref={"_root"} className="BarSegment" style={{ flex: ratio }}>
                <div className="BarSegment_bin">
                    <div className="BarSegment_bin_midpt" />
                    <div
                        style={{ background: `${color}`, height: "5px" }}
                        className={`BarSegment_bin_range`}
                    />
                    <div className="BarSegment_bin_threshold" />
                </div>
                <h5
                    style={{
                        color: greyPalette.medGrey,
                        position: "absolute",
                        right: 0,
                        bottom: 0,
                        margin: "50px -15px -15px 0px"
                    }}
                >
                    {threshold.max
                        ? `${threshold.max > 0 ? "+" : ""}${threshold.max}%`
                        : ""}
                </h5>
            </div>
        );
    }
}

export default SegmentedBarSegment;



// WEBPACK FOOTER //
// ./src/components/SegmentedBar/SegmentedBarSegment.js